import React, { useState } from 'react';
import { Popover, RadioButton, Text } from '../../../../design-system';
import { useTranslation } from 'react-i18next';
import { ExposedFiltersTypes, FilterTypes } from '../../../constants/initialFilters';
import { FilterOption } from '../../../types';
import { RadioButtonWrapper, VehicleTypeWrapper } from './VehicleType.styles';
import { ButtonStyled, InfoIconWrapper } from '../../CheckboxComponent/CheckboxSelector.styles';
import FilterSection from '../FilterSection';

interface VehicleTypeProps {
  filterType: string;
  vehicleTypeOptions: {
    [key: string]: FilterOption;
  };
  confirmedFilters: FilterTypes;

  availableFilters: string[];
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string, isChecked?: boolean) => void;
  handleExposeFilter: (arg: string) => void;
}

const VehicleType: React.FC<VehicleTypeProps> = ({
  filterType,
  vehicleTypeOptions,
  confirmedFilters,
  handleAddFilter,
  handleExposeFilter,
  openedFiltersList,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const listOfvehicleTypes = Object.keys(vehicleTypeOptions);

  const selectedTypeLabel = vehicleTypeOptions[confirmedFilters.vehicleType].label as string;

  return (
    <FilterSection
      filterType={filterType}
      selectedFilterLabels={selectedTypeLabel}
      openedFiltersList={openedFiltersList}
      handleExposeFilter={handleExposeFilter}
    >
      <VehicleTypeWrapper data-testid="vehicleType-list">
        {listOfvehicleTypes.map((vehicleType) => {
          const vehicleTypeObject = vehicleTypeOptions[vehicleType];
          const { value } = vehicleTypeObject;
          return (
            <RadioButtonWrapper key={vehicleTypeObject.value}>
              <RadioButton
                checked={vehicleTypeObject.value === confirmedFilters.vehicleType}
                data-testid={`vehicleType-list-${vehicleTypeObject.value}`}
                id="RadioButton-id-a"
                label={vehicleTypeObject.label as string}
                value={value}
                margin={[0, 0, 0, 0]}
                name="story"
                onClick={() => handleAddFilter(filterType, vehicleTypeObject.value)}
              />
              {value === 'USED-CAR' && (
                <InfoIconWrapper>
                  <Popover
                    aria-label="Popover title"
                    id="popover_title"
                    triggerElement={
                      <ButtonStyled
                        variant="tertiary"
                        icon="info-circle"
                        size="sm"
                        onClick={() => setIsOpen(!isOpen)}
                      />
                    }
                    open={isOpen}
                    content={
                      <>
                        <Text
                          variant={{
                            order: '2',
                            style: 'normal',
                          }}
                        >
                          {t(`promo.filters.filterOptions.vehicleType.popover`)}
                        </Text>
                      </>
                    }
                    onClose={() => setIsOpen(false)}
                    withTip
                  />
                </InfoIconWrapper>
              )}
            </RadioButtonWrapper>
          );
        })}
      </VehicleTypeWrapper>
    </FilterSection>
  );
};

export default VehicleType;
